import XeroLogoGenericRound from './xero-logo-generic-round';

export * from './xero-logo-generic-round';
export default XeroLogoGenericRound;
